define('modules/form_editor/views/editor_custom_email',['require','exports','module','./editor_text','ldsh!../templates/editor_custom_email'],function(require,exports,module){
  "use strict";

  var EditorText = require("./editor_text");
  module.exports = EditorText.extend({
    template: require("ldsh!../templates/editor_custom_email"),
  });
});

